import { useState, FormEvent } from 'react';
import { Link } from 'react-router-dom';

const milestones = [
  { year: '2018', title: '韩漫画网上线', desc: '怀揣对韩国漫画的热爱，韩漫画网正式上线，开启韩漫免费阅读之旅。' },
  { year: '2019', title: '资源突破千部', desc: '平台韩漫资源突破1000部，覆盖恋爱、动作、奇幻等六大品类。' },
  { year: '2020', title: '推出下拉式阅读', desc: '创新推出下拉式完整版阅读体验，让用户畅享无缝阅读的乐趣。' },
  { year: '2022', title: '用户突破百万', desc: '月活跃用户突破100万，成为中文互联网最受欢迎的韩漫阅读平台之一。' },
  { year: '2024', title: '无删减内容承诺', desc: '全面推行无删减漫画免费阅读政策，坚持为用户提供完整、原汁原味的韩漫内容。' },
  { year: '2026', title: '韩漫大全生态', desc: '构建韩漫大全内容生态，每日更新，平台资源持续增长，用户体验不断优化。' },
];

const values = [
  {
    icon: 'ri-shield-check-line',
    title: '完整无删减',
    desc: '我们坚持提供完整版韩漫，不做任何删减处理，让每位读者享受最原汁原味的阅读体验。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '每日更新',
    desc: '专业内容团队每日更新漫画资源，热门连载保持同步，确保您总有新书可看。',
  },
  {
    icon: 'ri-device-line',
    title: '全平台适配',
    desc: '下拉式阅读设计完美适配电脑、平板和手机，随时随地畅享韩漫阅读。',
  },
  {
    icon: 'ri-user-heart-line',
    title: '用户至上',
    desc: '以读者体验为中心，持续优化产品功能，打造最舒适的韩漫在线阅读平台。',
  },
];

export default function About() {
  const [formState, setFormState] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formMessage, setFormMessage] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypotValue = (formData.get('website_alt') as string || '').trim();
    if (honeypotValue) {
      setFormState('success');
      setFormMessage('感谢您的留言，我们会尽快回复！');
      form.reset();
      return;
    }

    setFormState('loading');
    setFormMessage('');

    try {
      const response = await fetch('http://uure9.cn/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(
          Array.from(formData.entries())
            .filter(([key]) => key !== 'website_alt')
            .map(([key, value]) => [key, value.toString()])
        ).toString(),
      });

      const responseText = await response.text();
      let parsed: Record<string, unknown> | null = null;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed && (parsed as Record<string, unknown>).code === 'OK') {
        setFormState('success');
        setFormMessage('感谢您的留言，我们会尽快回复！');
        form.reset();
      } else {
        const serverMsg =
          (parsed as Record<string, unknown> | null)?.['meta'] as Record<string, unknown> | undefined;
        const msg = serverMsg?.['message'] || serverMsg?.['detail'] ||
          (parsed as Record<string, unknown> | null)?.['message'] || responseText || '提交失败，请稍后重试。';
        setFormState('error');
        setFormMessage(String(msg));
      }
    } catch {
      setFormState('error');
      setFormMessage('网络错误，请检查网络后重试。');
    }
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于韩漫画网',
            description: '韩漫画网 - 下拉式完整版韩漫免费阅读平台，提供无删减韩国漫画在线阅读服务。了解我们的品牌故事、发展历程和核心价值。',
            url: 'http://uure9.cn/about',
            isPartOf: {
              '@type': 'WebSite',
              name: '韩漫画网',
              url: 'http://uure9.cn/',
            },
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                {
                  '@type': 'ListItem',
                  position: 1,
                  name: '首页',
                  item: 'http://uure9.cn/',
                },
                {
                  '@type': 'ListItem',
                  position: 2,
                  name: '关于我们',
                  item: 'http://uure9.cn/about',
                },
              ],
            },
          }),
        }}
      />

      <div className="pt-20 md:pt-24 pb-16 md:pb-24 bg-background-50">
        <div className="w-full px-4 md:px-6">
          <nav className="flex items-center gap-2 text-xs md:text-sm text-foreground-400 mb-6" aria-label="面包屑导航">
            <Link to="/" className="hover:text-primary-500 transition-colors duration-200">首页</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-foreground-600">关于我们</span>
          </nav>

          <div className="max-w-4xl">
            <p className="text-primary-500 text-sm font-medium tracking-widest mb-3">/ 关于韩漫画网</p>
            <h1 className="font-heading text-2xl md:text-5xl font-bold text-foreground-950 mb-6 leading-tight">
              下拉式完整版韩漫免费阅读
              <br />
              <span className="text-foreground-400">为漫画爱好者而生</span>
            </h1>
            <p className="text-foreground-500 text-sm md:text-lg leading-relaxed max-w-2xl mb-3">
              韩漫画网成立于2018年，是国内领先的韩国漫画免费阅读平台。
              我们致力于为中文读者提供最优质的韩漫阅读体验，
              涵盖恋爱甜宠、热血动作、悬疑惊悚、奇幻冒险、都市生活和古风华韵等六大品类。
            </p>
            <p className="text-foreground-500 text-sm md:text-lg leading-relaxed max-w-2xl">
              从创立之初，我们就坚持<strong>完整版、无删减</strong>的内容理念，
              创新推出<strong>下拉式阅读模式</strong>，让用户告别翻页的繁琐，
              享受沉浸式的漫画阅读体验。
            </p>
          </div>
        </div>
      </div>

      <section className="py-16 md:py-24 bg-background-100">
        <div className="w-full px-4 md:px-6">
          <div className="text-center mb-12 md:mb-16">
            <p className="text-accent-500 text-sm font-medium tracking-widest mb-3">发展历程</p>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              我们的故事
            </h2>
          </div>

          <div className="max-w-3xl mx-auto">
            <div className="relative">
              <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-background-300 md:-translate-x-px"></div>

              <div className="flex flex-col gap-8">
                {milestones.map((item, index) => (
                  <div
                    key={index}
                    className={`relative flex flex-col md:flex-row gap-4 md:gap-8 ${
                      index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                    }`}
                  >
                    <div className={`flex-1 ${index % 2 === 0 ? 'md:text-right' : 'md:text-left'}`}>
                      <div className="bg-background-50 rounded-xl p-5 border border-background-200/70">
                        <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-2">
                          {item.year}
                        </span>
                        <h3 className="text-foreground-900 font-heading font-semibold text-base mb-1">
                          {item.title}
                        </h3>
                        <p className="text-foreground-500 text-sm leading-relaxed">
                          {item.desc}
                        </p>
                      </div>
                    </div>

                    <div className="flex items-center justify-center flex-shrink-0">
                      <div className="w-8 h-8 rounded-full bg-accent-500 flex items-center justify-center relative z-10">
                        <div className="w-3 h-3 rounded-full bg-background-50"></div>
                      </div>
                    </div>

                    <div className="flex-1 hidden md:block"></div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-background-50">
        <div className="w-full px-4 md:px-6">
          <div className="text-center mb-12 md:mb-16">
            <p className="text-primary-500 text-sm font-medium tracking-widest mb-3">核心价值</p>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              为什么选择韩漫画网
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6 max-w-5xl mx-auto">
            {values.map((item, index) => (
              <div
                key={index}
                className="text-center p-6 rounded-xl bg-background-100 border border-background-200/70"
              >
                <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-accent-100 flex items-center justify-center mx-auto mb-4">
                  <i className={`${item.icon} text-accent-600 text-xl md:text-2xl`}></i>
                </div>
                <h3 className="text-foreground-900 font-heading font-semibold text-base mb-2">
                  {item.title}
                </h3>
                <p className="text-foreground-500 text-xs md:text-sm leading-relaxed">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-background-100" id="contact">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-5xl mx-auto">
            <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
              <div className="lg:w-2/5">
                <p className="text-accent-500 text-sm font-medium tracking-widest mb-3">联系我们</p>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
                  与我们取得联系
                </h2>
                <p className="text-foreground-500 text-sm leading-relaxed mb-8">
                  如果您有任何问题、建议或合作意向，欢迎通过下方表单联系我们。
                  我们会在24小时内回复您的留言。
                </p>

                <div className="flex flex-col gap-4">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-mail-line text-accent-600"></i>
                    </div>
                    <div>
                      <p className="text-foreground-400 text-xs">邮箱</p>
                      <p className="text-foreground-700 text-sm">hello@uure9.cn</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-wechat-line text-accent-600"></i>
                    </div>
                    <div>
                      <p className="text-foreground-400 text-xs">微信公众号</p>
                      <p className="text-foreground-700 text-sm">韩漫画网</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-weibo-line text-accent-600"></i>
                    </div>
                    <div>
                      <p className="text-foreground-400 text-xs">新浪微博</p>
                      <p className="text-foreground-700 text-sm">@韩漫画网官方</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="lg:w-3/5">
                <form
                  onSubmit={handleSubmit}
                 
                  className="bg-background-50 rounded-xl p-6 md:p-8 border border-background-200/70"
                >
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                    <div>
                      <label htmlFor="contact-name" className="block text-foreground-600 text-xs font-medium mb-1.5">
                        姓名 <span className="text-accent-500">*</span>
                      </label>
                      <input
                        type="text"
                        id="contact-name"
                        name="name"
                        required
                        className="w-full px-4 py-2.5 rounded-lg bg-background-100 border border-background-200 text-foreground-800 text-sm outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-300 transition-all duration-200"
                        placeholder="请输入您的姓名"
                      />
                    </div>
                    <div>
                      <label htmlFor="contact-email" className="block text-foreground-600 text-xs font-medium mb-1.5">
                        邮箱 <span className="text-accent-500">*</span>
                      </label>
                      <input
                        type="email"
                        id="contact-email"
                        name="email"
                        required
                        className="w-full px-4 py-2.5 rounded-lg bg-background-100 border border-background-200 text-foreground-800 text-sm outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-300 transition-all duration-200"
                        placeholder="请输入您的邮箱"
                      />
                    </div>
                  </div>

                  <div className="mb-4">
                    <label htmlFor="contact-subject" className="block text-foreground-600 text-xs font-medium mb-1.5">
                      主题
                    </label>
                    <input
                      type="text"
                      id="contact-subject"
                      name="subject"
                      className="w-full px-4 py-2.5 rounded-lg bg-background-100 border border-background-200 text-foreground-800 text-sm outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-300 transition-all duration-200"
                      placeholder="请输入留言主题"
                    />
                  </div>

                  <div className="mb-4">
                    <label htmlFor="contact-message" className="block text-foreground-600 text-xs font-medium mb-1.5">
                      留言内容 <span className="text-accent-500">*</span>
                    </label>
                    <textarea
                      id="contact-message"
                      name="message"
                      required
                      maxLength={500}
                      rows={5}
                      className="w-full px-4 py-2.5 rounded-lg bg-background-100 border border-background-200 text-foreground-800 text-sm outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-300 transition-all duration-200 resize-none"
                      placeholder="请输入您的留言内容（最多500字）"
                    ></textarea>
                    <p className="text-foreground-400 text-[10px] mt-1 text-right">最多500字</p>
                  </div>

                  <input
                    type="text"
                    name="website_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    className="contact-hp-field"
                  />

                  <button
                    type="submit"
                    disabled={formState === 'loading'}
                    className="w-full py-3 bg-primary-500 hover:bg-primary-600 disabled:bg-primary-300 text-background-50 font-medium rounded-lg text-sm transition-all duration-300 cursor-pointer whitespace-nowrap"
                  >
                    {formState === 'loading' ? '提交中...' : '发送留言'}
                  </button>

                  {formMessage && (
                    <p className={`mt-3 text-sm text-center ${
                      formState === 'success' ? 'text-primary-600' : 'text-accent-600'
                    }`}>
                      {formMessage}
                    </p>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}